import { useEffect, useState } from "react";
import { api, trackVisit } from "../lib/api";
import PageHero from "../components/site/PageHero";

const MODENA = "https://images.unsplash.com/photo-1715889546363-e8f0c43d0127?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxNb2RlbmElMjBJdGFseSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzkwNTM4OTV8MA&ixlib=rb-4.1.0&q=85";

export default function ChiSiamo() {
  const [about, setAbout] = useState({});

  useEffect(() => {
    trackVisit("chi-siamo");
    api.get("/content").then((r) => setAbout(r.data?.about || {}));
  }, []);

  return (
    <div data-testid="chi-siamo-page">
      <PageHero eyebrow="Chi Siamo" title="Una storia di fiducia," titleAccent="lunga una generazione." />

      <section className="py-20">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <p className="font-serif text-2xl md:text-3xl text-white leading-snug mb-8">{about.intro}</p>
            <p className="text-[var(--text-secondary)] leading-relaxed">{about.story}</p>
          </div>
          <div className="lg:col-span-5">
            <img src={MODENA} alt="Modena" className="w-full h-[400px] object-cover rounded-sm" />
            <p className="text-xs text-white/40 mt-3 italic">Modena, città del bello e del ben fatto.</p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#060f1f]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <h2 className="font-serif text-4xl text-white mb-12 text-center">I nostri <span className="gold-text italic">valori.</span></h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {(about.values || []).map((v, i) => (
              <div key={i} className="luxe-card p-8">
                <div className="font-serif gold-text text-3xl mb-3">0{i + 1}</div>
                <h3 className="font-serif text-xl text-white mb-2">{v.title}</h3>
                <p className="text-sm text-[var(--text-secondary)] leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
